"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _styles = require("../../../utils/styles");

var _overrides = require("../../../utils/overrides");

var _PreviousArrow = _interopRequireDefault(require("./PreviousArrow"));

var _NextArrow = _interopRequireDefault(require("./NextArrow"));

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Carousel');

var _ref2 = /*#__PURE__*/_react.default.createElement(_PreviousArrow.default, null);

var _ref3 = /*#__PURE__*/_react.default.createElement(_NextArrow.default, null);

function Carousel(_ref) {
  var className = _ref.className,
      sliderClassName = _ref.sliderClassName,
      dotsClassName = _ref.dotsClassName,
      speed = _ref.speed,
      lazyload = _ref.lazyload,
      dots = _ref.dots,
      arrows = _ref.arrows,
      content = _ref.content,
      overridesProp = _ref.overrides;
  var classes = (0, _overrides.useClasses)(useStyles); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Carousel.overrides);
  var rootClass = (0, _classnames3.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.withDots, dots && (content === null || content === void 0 ? void 0 : content.length) > 1));
  var sliderClass = (0, _classnames3.default)(classes.slider, sliderClassName, (0, _defineProperty2.default)({}, classes.withArrows, arrows));
  var contentClass = (0, _classnames3.default)(classes.content);
  var dotsClass = (0, _classnames3.default)(classes.dotsContainer, dotsClassName);
  var sliderRef = (0, _react.useRef)();
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: rootClass
  }, override.root), /*#__PURE__*/_react.default.createElement(_reactSlick.default, (0, _extends2.default)({
    ref: sliderRef,
    className: sliderClass,
    arrows: arrows,
    dots: dots,
    speed: speed,
    lazyload: lazyload,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    centerMode: false,
    accessibility: false,
    dotsClass: dotsClass,
    prevArrow: _ref2,
    nextArrow: _ref3
  }, override.Slider), content.map(function (singleContent, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: contentClass
    }, singleContent);
  })));
}

Carousel.overrides = ['root', 'Slider'];
Carousel.defaultProps = {
  speed: 500,
  lazyload: 'ondemand',
  dots: false,
  arrows: true
};
process.env.NODE_ENV !== "production" ? Carousel.propTypes = {
  className: _propTypes.default.string,
  sliderClassName: _propTypes.default.string,
  dotsClassName: _propTypes.default.string,
  speed: _propTypes.default.number,
  lazyload: _propTypes.default.oneOf(['ondemand', 'progressive']),
  dots: _propTypes.default.bool,
  arrows: _propTypes.default.bool,
  content: _propTypes.default.arrayOf(_propTypes.default.node)
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Carousel);

exports.default = _default;